module.exports = __webpack_public_path__ + "static/media/productIntroForm5.e29bc0c3.jpg";